'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ActionPanel: ()=>ActionPanel
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_ActionPanel_variants_cjs_namespaceObject = require("./ActionPanel.variants.cjs");
const ButtonController_cjs_namespaceObject = require("./atoms/ButtonController.cjs");
var ButtonController_cjs_default = /*#__PURE__*/ __webpack_require__.n(ButtonController_cjs_namespaceObject);
const SelectButton_cjs_namespaceObject = require("./atoms/SelectButton.cjs");
var SelectButton_cjs_default = /*#__PURE__*/ __webpack_require__.n(SelectButton_cjs_namespaceObject);
const useActionPanelContext_cjs_namespaceObject = require("./hooks/useActionPanelContext.cjs");
const useActionPanelGroupContext_cjs_namespaceObject = require("./hooks/useActionPanelGroupContext.cjs");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
function ActionPanel(props) {
    const { children, elevated, slots = {
        baseSlot: ''
    } } = props;
    const panelGroupContext = (0, useActionPanelGroupContext_cjs_namespaceObject.useActionPanelGroupContext)();
    const panelContextValue = (0, useActionPanelContext_cjs_namespaceObject.populateActionPanelContext)(props, panelGroupContext);
    const { baseSlot } = (0, external_ActionPanel_variants_cjs_namespaceObject.ActionPanelVariants)({
        elevated
    });
    const baseSlotClasses = (0, index_cjs_namespaceObject.cn)(baseSlot(), slots.baseSlot);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(useActionPanelContext_cjs_namespaceObject.ActionPanelContext.Provider, {
        value: panelContextValue,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("label", {
            "data-testid": "action-panel",
            className: baseSlotClasses,
            children: [
                children,
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(SelectButton_cjs_default(), {})
            ]
        })
    });
}
ActionPanel.Title = function({ children, slots = {
    titleSlot: '',
    titleContentSlot: ''
} }) {
    const { titleSlot, titleContentSlot } = (0, external_ActionPanel_variants_cjs_namespaceObject.ActionPanelVariants)({});
    const titleSlotClasses = (0, index_cjs_namespaceObject.cn)(titleSlot(), slots.titleSlot);
    const titleContentSlotClasses = (0, index_cjs_namespaceObject.cn)(titleContentSlot(), slots.titleContentSlot);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        "data-testid": "action-panel-title",
        className: titleSlotClasses,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ButtonController_cjs_default(), {
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                "data-testid": "action-panel-title-content",
                className: titleContentSlotClasses,
                children: children
            })
        })
    });
};
ActionPanel.Content = function({ children, slots = {
    contentSlot: ''
} }) {
    const childrenRef = (0, external_react_namespaceObject.useRef)(null);
    const [childrenHeight, setChildrenHeight] = (0, external_react_namespaceObject.useState)(0);
    const { contentSlot } = (0, external_ActionPanel_variants_cjs_namespaceObject.ActionPanelVariants)({});
    const contentSlotClasses = (0, index_cjs_namespaceObject.cn)(contentSlot(), slots.contentSlot);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (childrenRef.current) setChildrenHeight(childrenRef.current.offsetHeight);
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        "data-testid": "action-panel-content",
        className: contentSlotClasses,
        "data-children-height": childrenHeight,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
            ref: childrenRef,
            className: "p-4",
            children: children
        })
    });
};
exports.ActionPanel = __webpack_exports__.ActionPanel;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ActionPanel"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
